import { beginAvailabilityRequest } from '~/utils/applicationAvailability'

export const actions = {
	async templates(_, payload) {
		return this.$axios.$post('/application/rejection/templates', payload, {
			__skipGlobalErrorToast: true
		})
	},
	async preview(_, payload) {
		return this.$axios.$post('/application/rejection/preview', payload, {
			__skipGlobalErrorToast: true
		})
	},
	async send({ rootState, commit }, payload) {
		const availabilityRequest = beginAvailabilityRequest(
			rootState.application,
			(name, value) =>
				commit(`application/${name}`, value, { root: true })
		)
		const result = await this.$axios.$post(
			'/application/rejection',
			payload,
			{
				__skipGlobalErrorToast: true
			}
		)
		return {
			...result,
			availabilityRequest,
			sessionGeneration: availabilityRequest.sessionGeneration
		}
	}
}
